import { ViewFactory } from 'wdc-cube-react'
import PFScope, { HeaderScope } from '../pf.scopes'
import PFView from './pf.view'
import HeaderView from './pf.header'

export function registerViews(rv = ViewFactory.register) {
    rv(PFScope, PFView)
    rv(HeaderScope, HeaderView)
}
